import { hexToRgba, isColorLight } from "../../../utils/FunctionsGlobals";

/* eslint-disable import/no-anonymous-default-export */
export interface ISearchTypes {
    label: string;
    options: Array<{ label: string; value: string; type: string }>;
}

export interface ISearchCode {
    label: string;
    value: string;
    type: string;
}

export const SearchCity: Array<ISearchCode> = [
    { label: 'Campina Grande', value: '1', type: 'city' },
    { label: 'João Pessoa', value: '2', type: 'city' },
    { label: 'Patos', value: '3', type: 'city' },
    { label: 'São Paulo', value: '4', type: 'city' },
    { label: 'Minas Gerais', value: '5', type: 'city' },
    { label: 'Novo Hamburgo', value: '6', type: 'city' },
    { label: 'Campo Bom', value: '7', type: 'city' },
];

export const SearchDistrict: Array<ISearchCode> = [
    { label: 'Campos', value: '1', type: 'district' },
    { label: 'Centro', value: '2', type: 'district' },
    { label: 'Jardins', value: '3', type: 'district' },
    { label: 'Flores', value: '4', type: 'district' },
    { label: 'Portal', value: '5', type: 'district' },
];

export const SearchType: Array<ISearchCode> = [
    { label: 'Apartamento', value: '1', type: 'type' },
    { label: 'Casa', value: '2', type: 'type' },
    { label: 'Casa em Condomínio', value: '3', type: 'type' },
    { label: 'Cobertura', value: '4', type: 'type' },
    { label: 'Terreno', value: '5', type: 'type' },
];

export const SearchCode: Array<ISearchCode> = [
    { label: '36', value: '36', type: 'code' },
    { label: '45', value: '45', type: 'code' },
    { label: '65', value: '65', type: 'code' },
    { label: '110', value: '110', type: 'code' },
    { label: '115', value: '115', type: 'code' },
    { label: '135', value: '135', type: 'code' },
];

const customSelectStyles = (color: string, colorArrow?: string) => {
    return {
        control: (base: any) => ({
            ...base,
            background: 'transparent',
            boxShadow: 'none',
            border: 0,
        }),
        dropdownIndicator: (base: any) => ({
            ...base,
            color: colorArrow || 'white',
        }),
        placeholder: (base: any) => ({
            ...base,
            color: 'white',
        }),
        singleValue: (base: any) => ({
            ...base,
            color: 'white',
        }),
        input: (base: any) => ({
            ...base,
            color: 'white',
        }),
        indicatorSeparator: (base: any) => ({
            ...base,
            backgroundColor: colorArrow || 'transparent',
        }),
    };
};

export const customSelectPropertiesStyles = (color: string,backgr: string,select: string, colorArrow?: string) => ({
  control: (base: any) => ({
    ...base,
    background: hexToRgba(backgr, 0.6),
    boxShadow: 'none',
    border: `0.1px solid ${hexToRgba(color, 0.1)} !important`,
    borderRadius: 50,       // >>> pílula interna
    minHeight: 50,
    cursor: 'pointer',
    ':hover': {boxShadow: `0 1px 8px 0 ${hexToRgba(color, 0.1)};`}
  }),
  container: (base: any) => ({
    ...base,
    color: color || '#fff',
    flex: 1
  }),
  dropdownIndicator: (base: any) => ({
    ...base,
    color: colorArrow || '#fff',
    paddingRight: 12,
    
    zIndex: 99,
    ':hover': { color: colorArrow || '#fff' },
  }),
  indicatorSeparator: (base: any) => ({
    ...base,
    backgroundColor: 'transparent',
  }),
  placeholder: (base: any) => ({
    ...base,
    color: colorArrow || '#fff',
    fontWeight: 500,
    fontSize: 15,
  }),
  singleValue: (base: any) => ({
    ...base,
    color: color || '#fff',
    fontWeight: 500,
    fontSize: 15,
  }),
  

  /* DROPDOWN ---------------------------------------------------- */
  /**  <-  fundo da caixa que contém todas as opções  */
  menu: (base: any) => ({
    ...base,
    backgroundColor: backgr,
    zIndex: 10000,          // maior que o header/menu
  }),
  /**  <-  área do scroll em si (útil p/ remover padding)  */
  menuList: (base: any) => ({
    ...base,
    padding: 0
  }),
  /**  <-  cada <option> individual  */
  option: (base: any, state: any) => ({
    ...base,
    backgroundColor: state.isSelected
      ? select                    // selecionado
      : state.isFocused
      ? select                    // hover
      : backgr,                   // normal
    color: state.isSelected && !isColorLight(select)
      ? "#FFFFFF"                    // selecionado
      : state.isFocused && !isColorLight(select)
      ? "#FFFFFF"                      // hover
      : color, 
    cursor: 'pointer',
    ':active': { backgroundColor: backgr },
  }),
});

export default {
    customSelectStyles,
    customSelectPropertiesStyles,
};
